// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { invSupplierId } from './InvSupplier';
import { calendarDate } from '../../calendar-date';
import { invPurchaseOrderStatusEnum } from './InvPurchaseOrderStatusEnum';
import { z } from 'zod';
export const invPurchaseOrderId = (z.number());
export const invPurchaseOrder = z.object({
    id: invPurchaseOrderId,
    supplier_id: invSupplierId,
    order_date: calendarDate.nullable(),
    expected_delivery_date: calendarDate.nullable(),
    status: invPurchaseOrderStatusEnum,
    created_at: z.date().nullable(),
    updated_at: z.date().nullable(),
});
export const invPurchaseOrderInitializer = z.object({
    id: invPurchaseOrderId.optional(),
    supplier_id: invSupplierId,
    order_date: calendarDate.optional().nullable(),
    expected_delivery_date: calendarDate.optional().nullable(),
    status: invPurchaseOrderStatusEnum.optional(),
    created_at: z.date().optional().nullable(),
    updated_at: z.date().optional().nullable(),
});
export const invPurchaseOrderMutator = z.object({
    id: invPurchaseOrderId.optional(),
    supplier_id: invSupplierId.optional(),
    order_date: calendarDate.optional().nullable(),
    expected_delivery_date: calendarDate.optional().nullable(),
    status: invPurchaseOrderStatusEnum.optional(),
    created_at: z.date().optional().nullable(),
    updated_at: z.date().optional().nullable(),
});
//# sourceMappingURL=InvPurchaseOrder.js.map